import { Box, InputBase, MenuItem, Select, Typography } from "@mui/material";
import HeaderSection from "./header-section";
import SearchSection from "./search-section";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { setSelectedHp } from "slices/searchListingReducer";

const types = [
  {
    header: "25HP",
    subheading: "Small or sub-compact tractors",
    description:
      "Landscaping, gardening, and light-duty farming. Best for homeowners & hobby farmers",
  },
  {
    header: "26-50 HP",
    subheading: "Compact Tractors",
    description:
      "For small farms, and big gardens.  Used for mowing, hauling, light grading, tilling, and basic garden or farm work.",
  },
  {
    header: "51-99 HP",
    subheading: "Utility tractors",
    description:
      "Very versatile for general farm tasks like ploughing, baling, digging and hauling. ",
  },
  {
    header: "100-200 HP",
    subheading: "Mid-range tractors",
    description:
      "Experience optimal power and maneuverability with our multi-purpose tractor.",
  },
  {
    header: "200-299 HP",
    subheading: "Large to high powered tractors",
    description:
      "Designed for heavy duty work. Commercial farming, and industrial settings.",
  },
  {
    header: "300 and above HP",
    subheading: "High-powered or Row-Crop tractor",
    description:
      "Handles the biggest jobs. Built to pull and power the biggest implements, allowing growers to plant and harvest more efficiently.",
  },
];

const HorsePowerSection = ({
  onClose,
  selectionBox = false,
}: {
  onClose: any;
  selectionBox?: Boolean;
}) => {
  const { selectedHp } = useAppSelector((state) => state.searchListingReducer);
  const [selected, setSelected] = useState(selectedHp);
  const dispatch = useAppDispatch();

  const handleChangeHp = (i: number) => {
    dispatch(setSelectedHp(selected === i ? 0 : i));
    setSelected(selected === i ? 0 : i);
    onClose();
  };

  if (selectionBox) {
    return (
      <Box sx={{ position: "relative" }}>
        <Select
          input={
            <InputBase
              placeholder="By Horse Power"
              sx={{
                border: "1px solid #E2E2E2",
                height: "56px",
                borderRadius: "10px",

                pl: "20px",
              }}
            />
          }
          label="By Horse Power"
          fullWidth
          IconComponent={() => (
            <img
              src="/assets/img/icons/arrow_down.svg"
              alt=""
              style={{ marginRight: "10px" }}
            />
          )}
          onChange={({ target }: any) => {
            handleChangeHp(target.value);
          }}
          value={selectedHp}
        >
          {types.map((t: any, index) => (
            <MenuItem value={index + 1}>{t.header}</MenuItem>
          ))}
        </Select>
        {!selectedHp && (
          <Typography
            sx={{
              color: "#A2A2A2",
              fontSize: "15px",
              fontWeight: 400,
              position: "absolute",
              top: "17px",
              left: "20px",
            }}
          >
            By Horse Power
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ width: "600px" }}>
      <HeaderSection
        label="By Horse Power"
        disabledClearAll={true}
        onClose={onClose}
        showClearAll={false}
      />

      <Box
        sx={{
          px: "4%",
          py: "25px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        {types.map((t: any, index) => (
          <Box
            sx={{
              border:
                selected === index + 1
                  ? "1px solid #6E8C20"
                  : "1px solid #E2E2E2",
              background: selected === index + 1 ? "#E1FFA2" : "#FFF",
              borderRadius: "10px",
              p: "20px",

              display: "flex",
              flexDirection: "column",
              gap: "10px",

              cursor: "pointer",
            }}
            role="button"
            onClick={() => {
              setSelected(index + 1);
              handleChangeHp(index + 1);
            }}
          >
            <Box sx={{ display: "flex", gap: "10px" }}>
              <img
                src="/assets/img/icons/hp_tractor.svg"
                height="48"
                width="48"
                alt=""
              />
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <Typography
                  sx={{
                    color: "#323232",
                    fontWeight: 600,
                    lineHeight: "20px",
                    fontSize: "16px",
                  }}
                >
                  {t.header}
                </Typography>
                <Typography
                  sx={{
                    color: "#323232",
                    fontWeight: 600,
                    lineHeight: "16px",
                    fontSize: "14px",
                  }}
                >
                  {t.subheading}
                </Typography>
              </Box>
            </Box>
            <Typography
              sx={{
                color: selected === index + 1 ? "#323232" : "#A2A2A2",
                fontSize: "15px",
                fontWeight: 400,
                lineHeight: "22px",
              }}
            >
              {t.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default HorsePowerSection;
